<template>
    <div class="modal" v-bind:class="modalClass">
        <div id="modal-overlay" @click="back()"></div>
        <article id="modal-edit" v-if="resource">
            <header>
                <figure>
                    <i v-if="!resource.picture" class="icon icon-icon_person"></i>
                    <img v-if="resource.picture" :src="resource.picture.url+'/fit/100x100'"/>
                </figure>
                <div>
                    <span class="breadcrumb">
                        Profile <i class="icon icon-icon_arrow-right"></i> Edit
                    </span>
                    <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>

                </div>
                <div class="spacer"></div>
                <div>
                    <button @click="back()" class="bt-back"><span><i class="icon icon-icon_arrow-left"></i></span></button>
                    <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                </div>
            </header>

            <languages :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

            <tabs :options="{ useUrlFragment: false }">
                <tab name="Information">

                    <form-scopes label='Scopes' v-model="resource"></form-scopes>

                    <form-file label="Image" v-model="resource.picture_id" width="300"></form-file>

                    <form-text label="Reference" v-model="resource.slug"></form-text>

                    <form-text label="Tracking url" v-model="resource.tracking_url"></form-text>

                    <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                        <form-text :lang="client.id" :label="'Name'" v-model="resource.translations[client.id].name"></form-text>
                    </div>

                    <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                        <form-text :lang="client.id" :label="'Headline'" v-model="resource.translations[client.id].headline"></form-text>
                    </div>

                    <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                        <form-textarea :lang="client.id" :label="'Description'" v-model="resource.translations[client.id].description"></form-textarea>
                    </div>

                </tab>
            </tabs>
        </article>
    </div>
</template>
<script>

    import RatingService from './RatingService.js';
    import Edit from '../../../layouts/Edit.vue';

    export default {
        extends: Edit,
        data () {
            return {
                resource: {
                },
                options: [],
                isLoading: false
            }
        },
        mounted: function(){

        },
        methods:{
            resourceLoaded: function(){
                this.setTranslations(['name','headline','description']);
            },
            beforeUpdate: function(){
                return true;
            },
            getResource: function(){
                return {name: 'rating', api: RatingService}
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/config/rating/Edit.vue